module.exports = __webpack_public_path__ + "static/media/Glyph.d50143a1.svg";